<div class="modal" style="background-color: rgba(255, 255, 255, 0.75)" [style.display]="expired ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <span>Your session has expired. <a href="javascript:void(0)" (click)="logout()">Please login again.</a></span>
            </div>
        </div>
    </div>
</div>